import React, { useEffect, useState } from "react";
import FormInputText from "../../FormInputText";
import {
  FormInputDropdown,
  generateSingleOptions,
} from "../../FormComponent/FormInputDropdown";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";

import {
  optionsUserCategory,
  optionsUserType,
} from "../../../select-options/options";
import { green } from "@mui/material/colors";
import styled from "@emotion/styled";
import { Link, useNavigate, useParams } from "react-router-dom";
import FileUpload from "../FileUpload";
import {
  baseUrl,
  useCreatePostJobApiMutation,
  useEditJobMutation,
  useFindJobByIdQuery,
} from "../../../services/apiSlice";
import Swal from "sweetalert2";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const EditJob = ({ userInfo }) => {
  let { jobId } = useParams();
  const {
    data: editData,
    error: errorsData,
    isError: Iserror,
    isSuccess,
    isFetching,
  } = useFindJobByIdQuery(jobId);
  const methods = useForm({
    // defaultValues: defaultValues,
  });
  const {
    handleSubmit,
    reset,
    control,

    watch,
    register,
    getValues,
    formState: { errors },
  } = methods;
  console.log({ jobId });
  const navigate = useNavigate();

  const [EditJob, { data, error, isError }] = useEditJobMutation();

  const [jobData, setJobData] = useState({
    job_description: "",
    job_categories: "",
    mobile_number: "",

    job_title: "",
    address: "",
    zip_code: "",
    company_name: "",
    email: "",
    company_website: "",
    error: false,
    loading: false,
    success: false,
  });

  const [errorNumber, setErrorNumber] = useState("");
  console.log({ editData });
  const [value, setValue] = useState();

  const fetchSingleJob = async (jobId) => {
    fetch(baseUrl + `api/v1/find-my-job/${jobId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userInfo,

        Accept: "application/json",
      },
      credentials: "same-origin",
    })
      .then(
        (response) => {
          if (response.ok) {
            return response;
          } else {
            var error = new Error(
              "Error " + response.status + ": " + response.statusText
            );
            error.response = response;
            throw error;
          }
        },
        (error) => {
          var errmess = new Error(error.message);
          throw errmess;
        }
      )
      .then((response) => response.json())
      .then((res) => {
        if (res.success === true) {
          console.log("it enter it enter");
          setJobData({
            job_title: res.getAvailableJob.title,
            address: res.getAvailableJob.address,
            job_categories: res.getAvailableJob.categories,
            job_description: res.getAvailableJob.job_description,
            email: res.getAvailableJob.email,
            zip_code: res.getAvailableJob.zip_code,
            company_name: res.getAvailableJob.company_name,
            mobile_number: res.getAvailableJob.mobile_number,
            company_website: res.getAvailableJob?.company_website,
          });
          setValue(res.getAvailableJob.mobile_number);

          console.log("response post ", res);
        } else {
          console.log("errorrrror");
        }
      })
      .catch((error) => console.error(error.message));
  };
  console.log("data", jobData);
  useEffect(() => {
    // fetch data for this particular job
    fetchSingleJob(jobId);
  }, [jobId]);
  const onSubmit = async (data) => {
    // event.preventDefault();
    console.log({ data });
    const formData = new FormData();
    if (data.images?.length > 0) {
      console.log("it enter images");
      data.images.forEach((el) => formData.append("images", el));
      formData.append("zip_code", jobData.zip_code);
      formData.append("job_title", jobData.job_title);
      formData.append("address", jobData.address);
      formData.append("job_categories", jobData.job_categories);
      formData.append("job_description", jobData.job_description);
      formData.append("email", jobData.email);
      formData.append("company_website", jobData.company_website);
      formData.append("mobile_number", jobData.mobile_number);
      formData.append("company_name", jobData.company_name);
      formData.append("jobId", jobId);
      try {
        const responseData = await EditJob(formData).unwrap();
        console.log(
          { responseData },
          "responseData?.message",
          responseData?.message
        );
        if (responseData?.success === true) {
          // success message
          Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
            (result) => {
              if (result.isConfirmed || result.isDismissed) {
                navigate(`/dashboard/my-job`);
              }
            }
          );
        } else if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (responseData?.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseData?.message,
          });
        } else if (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseData?.message,
          });
        }
      } catch (error) {
        if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message, error?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      }
    } else {
      console.log("it enter image");
      formData.append("image", data.image);
      formData.append("zip_code", jobData.zip_code);
      formData.append("job_title", jobData.job_title);
      formData.append("address", jobData.address);
      formData.append("job_categories", jobData.job_categories);
      formData.append("job_description", jobData.job_description);
      formData.append("email", jobData.email);
      formData.append("company_website", jobData.company_website);
      formData.append("mobile_number", value);
      formData.append("company_name", jobData.company_name);
      formData.append("jobId", jobId);
      try {
        const responseData = await EditJob(formData).unwrap();
        console.log(
          { responseData },
          "responseData?.message",
          responseData?.message
        );
        if (responseData?.success === true) {
          // success message
          Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
            (result) => {
              if (result.isConfirmed || result.isDismissed) {
                navigate(`/dashboard/my-job`);
              }
            }
          );
        } else if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (responseData?.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      } catch (error) {
        if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      }
    }
    console.log(data);
  };

  const handleValidate = (value) => {
    const isValid = isValidPhoneNumber(value);
    console.log({ isValid });
    if (!isValid) {
      // error = 'Number not valid'
      setErrorNumber("Not a valid number please try again later!!");
    }
    return isValid;
  };
  const [multipleUpload, setMultipleUpload] = useState(false);
  const methodss = useForm({
    // resolver: zodResolver(imageUploadSchema),
  });
  console.log({ multipleUpload });
  // console.log(methods.formState.errors);

  const onSubmitHandler = (values) => {
    const formData = new FormData();

    if (values.images?.length > 0) {
      values.images.forEach((el) => formData.append("images", el));
    } else {
      formData.append("image", values.image);
    }

    console.log(values);

    // Call the Upload API
    // uploadImage(formData);
  };
  return (
    <>
      <Container maxWidth={"lg"}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          className="min-h-screen"
          sx={{ mt: 5, ml: 4 }}
          style={{
            display: "flex",

            // padding: "20px",
            // margin: "4px 10px",
            flexDirection: "column",
          }}
        >
          <Card
            style={{
              display: "flex",
              gridRowGap: "20px",
              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
            sx={[
              { mx: 3, px: 4 },
              (theme) => ({
                [theme.breakpoints.down("321")]: {
                  width: "100%",
                  py: 3,
                  px: 1,
                  mx: 1,
                },
              }),
            ]}
          >
            <Typography
              variant="h1"
              component="h2"
              className="text-3xl uppercase font-extrabold text-center py-2 md:py-4 "
              sx={{ textAlign: "center" }}
            >
              Edit a Pro
            </Typography>
            <TextField
              // id="outlined-basic"
              label="Job Title"
              variant="outlined"
              fullWidth={true}
              size={"small"}
              // value={setValue(
              //   "job_title",
              //   !isFetching && editData?.getAvailableJob?.title
              // )}
              value={jobData.job_title}
              onChange={(e) =>
                setJobData({
                  ...jobData,
                  success: false,
                  error: false,
                  job_title: e.target.value,
                })
              }
              name="job_title"
              // {...register("job_title", {
              //   // required: "Job title is required",
              //   minLength: {
              //     value: 3,
              //     message: "Job title  should have at-least 3 characters.",
              //   },
              //   pattern: {
              //     value: /^[a-zA-Z]{3,}$/,
              //     message: "Job title  should contain only characters.",
              //   },
              // })}
              error={Boolean(jobData?.error)}
              // helperText={jobData.error && jobData?.error?.job_title}
            />

            <FormControl
              error={Boolean(errors.job_categories)}
              // helperText={errors.user_type?.message}
              size={"small"}
            >
              <InputLabel> What service are you looking for?</InputLabel>

              {/* <Controller
                rules={
                  {
                    // required: "Please select   the categories you belong to?",
                  }
                }
                render={({ field }) => (
                )}
                name="job_categories"
                control={control}
              /> */}
              <Select
                // value={setValue(
                //   "job_categories",
                //   !isFetching && editData?.getAvailableJob?.categories
                // )}
                // {...field}
                value={jobData.categories}
                onChange={(e) =>
                  setJobData({
                    ...jobData,
                    success: false,
                    error: false,
                    job_categories: e.target.value,
                  })
                }
              >
                {generateSingleOptions(optionsUserCategory)}
              </Select>
              <FormHelperText>{errors.job_categories?.message}</FormHelperText>
            </FormControl>

            <TextField
              id="outlined-basic"
              label="E-mail"
              variant="outlined"
              fullWidth
              // value={setValue(
              //   "email",
              //   !isFetching && editData?.getAvailableJob?.email
              // )}
              name="email"
              size={"small"}
              {...register("email", {
                // required: "Email is Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
              value={jobData.email}
              onChange={(e) =>
                setJobData({
                  ...jobData,
                  success: false,
                  error: false,
                  email: e.target.value,
                })
              }
              error={Boolean(errors.email)}
              helperText={
                errors.email && errors.email.type === "required"
                  ? errors.email.message
                  : errors.email &&
                    errors.email.type === "pattern" &&
                    errors.email.message
              }
            />

            <FormControl error={Boolean(errors.mobile_number)}>
              <PhoneInput
                // value={setValue(
                //   "mobile_number",
                //   !isFetching &&
                //     editData?.getAvailableJob?.mobile_number.substring(2)
                // )}
                name="mobile_number"
                value={value}
                onChange={(() => handleValidate(value), setValue)}
                // onChange={onChange}
                defaultCountry="US"
                id="phone-input"
                country="US"
                placeholder="Enter phone number"
                // onlyCountries={["us"]}

                className="border-4 py-1 px-2  border-gray-300"
              />
              <FormHelperText>{errors.mobile_number?.message}</FormHelperText>
              <FormHelperText>{errorNumber}</FormHelperText>
            </FormControl>

            <TextField
              id="outlined-basic"
              name="address"
              label="Address"
              variant="outlined"
              fullWidth
              // value={!isFetching && editData?.getAvailableJob?.address}
              size={"small"}
              // {...register("address", {
              //   // required: "Please specify your residential address",
              // })}
              value={jobData.address}
              onChange={(e) =>
                setJobData({
                  ...jobData,
                  success: false,
                  error: false,
                  address: e.target.value,
                })
              }
              error={Boolean(errors.address)}
              helperText={errors.address?.message}
            />
            <TextField
              id="outlined-basic"
              name="zip_code"
              label="Zip"
              // value={setValue(
              //   "zip_code",

              //   editData?.getAvailableJob?.zip_code
              // )}
              variant="outlined"
              fullWidth
              value={jobData.zip_code}
              onChange={(e) =>
                setJobData({
                  ...jobData,
                  success: false,
                  error: false,
                  zip_code: e.target.value,
                })
              }
              size={"small"}
              // {...register("zip_code", {
              //   // required: "Please specify your zip code or postal code",
              //   maxLength: {
              //     value: 5,
              //     message: "Zip code should not be more than 5  numbers.",
              //   },
              //   minLength: {
              //     value: 5,
              //     message: "Zip code should not be less than 5  numbers.",
              //   },
              // })}
            />

            <>
              <TextField
                id="outlined-basic"
                name="company_name"
                label="Company Name"
                // value={setValue(
                //   "company_name",

                //   editData?.getAvailableJob?.company_name
                // )}
                variant="outlined"
                fullWidth
                size={"small"}
                value={jobData.company_name}
                onChange={(e) =>
                  setJobData({
                    ...jobData,
                    success: false,
                    error: false,
                    company_name: e.target.value,
                  })
                }
                // {...register("company_name", {
                //   // required: "Please provide your company name is required.",
                // })}
                error={Boolean(errors.company_name)}
                helperText={errors.company_name?.message}
              />
              <TextField
                id="outlined-basic"
                name="company_website"
                label="Company Website"
                variant="outlined"
                fullWidth
                // {...register("company_website")}
                value={jobData?.company_website}
                onChange={(e) =>
                  setJobData({
                    ...jobData,
                    success: false,
                    error: false,
                    company_website: e.target.value,
                  })
                }
                // error={Boolean(errors.company_name)}
                // helperText={errors.company_name?.message}
              />
            </>

            <TextField
              id="outlined-multiline-static"
              label="Job Description"
              // value={setValue(
              //   "job_description",

              //   editData?.getAvailableJob?.job_description
              // )}
              multiline
              rows={4}
              name={"job_description"}
              // {...register("job_description", {
              //   // required:
              //   //   "Please tell us more about the job to match you with real pro.",
              //   minLength: {
              //     value: 20,
              //     message:
              //       "Job description  should have at-least 20 characters.",
              //   },
              // })}
              value={jobData.job_description}
              onChange={(e) =>
                setJobData({
                  ...jobData,
                  success: false,
                  error: false,
                  job_description: e.target.value,
                })
              }
              error={Boolean(errors.job_description)}
              helperText={errors.job_description?.message}
            />

            <Box
              display="flex"
              flexDirection="column"
              sx={[
                { width: "80%" },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "100%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              {/* Single Image Upload */}
              <FormProvider {...methods}>
                <Stack marginBottom={2}>
                  <Typography
                    textAlign="center"
                    variant="p"
                    component="p"
                    gutterBottom
                    sx={{
                      // mx: 3,
                      py: 3,
                    }}
                  >
                    Click to
                    {multipleUpload == false
                      ? "  Upload more than one photos of job "
                      : " upload Single photos of job here "}
                    <Button
                      sx={{
                        // background: "transparent",
                        // color: "black",
                        px: 3,
                        py: 2,
                        mx: 3,
                      }}
                      className="rounded-2xl border-green-500 text-black border-2 bg-green-500"
                      onClick={() => setMultipleUpload(!multipleUpload)}
                    >
                      {" "}
                      click here
                    </Button>
                  </Typography>
                  <FileUpload
                    required={false}
                    limit={multipleUpload === false ? 1 : 4}
                    multiple={multipleUpload === false ? false : true}
                    name={multipleUpload === false ? "image" : "images"}
                  />
                </Stack>
              </FormProvider>
            </Box>

            <FormGroup
              error={Boolean(errors.tnc)}
              style={{ display: "block", marginTop: "17px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name="tnc"
                    {...register("tnc", {
                      // required: "please aggre our terms and condtions",
                    })}
                  />
                }
                label="I agree all terms and conditions"
              />
            </FormGroup>
            <FormHelperText style={{ color: "#d32f2f" }}>
              {errors.tnc?.message}
            </FormHelperText>
            <div className="clearfix"></div>
            <Button
              variant="contained"
              type="submit"
              // size="small"
              className="hover:bg-green-300"
              sx={[
                {
                  color: "white",
                  background: green[600],
                  width: "40%",
                  mx: 30,
                  mb: 4,
                  px: 2,
                  py: 2,
                  textAlign: "center",
                  placeItems: "center",
                },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "80%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              Share Job to Pros
            </Button>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default EditJob;
